<template>
    <div class="qingwu">
        <div class="admin_main_block">
            <div class="admin_main_block_top">
                <div class="admin_main_block_left">

                    <!--<div><router-link to="/Admin/zhongzly/form"><el-button type="primary" icon="el-icon-plus">添加</el-button></router-link></div>-->
                    <div><el-input v-model="where.keyword" placeholder="请输入投诉内容或留言内容"></el-input></div>
                    <div><el-date-picker format="yyyy-MM-dd HH:mm" v-model="where.times" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker></div>
                    <div><el-button icon="el-icon-search" @click="get_agreement_list()">条件筛选</el-button></div>
                </div>
                <div class="admin_main_block_right">
                    <div><el-button type="danger" icon="el-icon-delete" @click="del(select_id)">批量删除</el-button></div>
                </div>
            </div>
            <div class="admin_table_main">
                <el-table :data="info" @selection-change="handleSelectionChange" >
                    <el-table-column type="selection"></el-table-column>
                    <!-- <el-table-column prop="id" label="#" fixed="left" width="70px"></el-table-column> -->
                    <el-table-column prop="F_IN_ID" label="#" ></el-table-column>
                    <el-table-column prop="F_TE_TOUSNR" label="投诉内容"></el-table-column>
                    <el-table-column prop="F_TE_LIUYNR" label="留言内容"></el-table-column>
                    <el-table-column prop="F_IN_LIUYID" label="留言ID"></el-table-column>
                    <el-table-column label="创建时间" >
                        <template slot-scope="scope">
                            <div>{{scope.row.F_IN_TOUSSJ|formatDate}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" fixed="right" width="160px">
                        <template slot-scope="scope">
                            <!--<el-button icon="el-icon-edit" @click="$router.push({name:'zhongzly_form',params:{F_IN_ID:scope.row.F_IN_ID}})">编辑</el-button>-->
                            <!-- <el-button type="danger" icon="el-icon-delete" @click="del(scope.row.id)">删除</el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
                <div class="admin_table_main_pagination">
                    <el-pagination @current-change="current_change" background layout="prev, pager, next,jumper,total" :total="total_data" :page-size="page_size" :current-page="current_page"></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {},
        props: {},
        data() {
            return {
                list:[],
                total_data:0, // 总条数
                page_size:20,
                current_page:1,
                select_id:'',
                where: {
                    times: [],
                },
            };
        },
        watch: {},
        computed: {},
        methods: {
            handleSelectionChange:function(e){
                let ids = [];
                e.forEach(v => {
                    ids.push(v.F_IN_ID);
                });
                this.select_id = ids.join(',');
            },
            get_agreement_list:function(){
                let where = {};
                where.page = this.current_page;
                where.params = this.where;
                this.$get(this.$api.getTousjl, where).then(res=>{
                    this.page_size = res.data.per_page;
                    this.total_data = res.data.total;
                    this.current_page = res.data.current_page;
                    this.info = res.data.data;

                })

            },
            // 删除处理
            del:function(F_IN_ID){
                if(this.$isEmpty(F_IN_ID)){
                    return this.$message.error('请先选择删除的对象');
                }
                this.$post(this.$api.delTousjl,{F_IN_ID:F_IN_ID}).then(res=>{
                    if(res.code == 200){
                        this.get_agreement_list();
                        return this.$message.success("删除成功");
                    }else{
                        return this.$message.error("删除失败");
                    }
                });
            },
            current_change:function(e){
                this.current_page = e;
                this.get_agreement_list();
            },
        },
        created() {
            this.get_agreement_list();
        },
        mounted() {}
    };
</script>
<style lang="scss" scoped>
</style>